import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { QrConfigService } from './qr-config.service';
@Component({
  selector: 'app-qr-config',
  templateUrl: './qr-config.component.html',
  styleUrls: ['./qr-config.component.sass']
})
export class QrConfigComponent implements OnInit {
  mode:any;
  mc:any;
  qrMedium:any;
  tn:any;
  pn:any;
  pa:any;
  constructor( private spinner : NgxSpinnerService,
    private toastr : ToastrService,
    private qrConfigService: QrConfigService) {}

  ngOnInit(): void {
  }
  qrConfig(){
    this.spinner.show();
    
    let data = {
      mode : this.mode,
      mc : this.mc,
      qrMedium : this.qrMedium ,
      tn : this.tn ,
      pn : this.pn , 
      pa : this.pa , 
    }
    console.log(data)
    this.qrConfigService.qrConfig(data).subscribe((result:any)=>{
      if(result.statusCode == 200){
        this.spinner.hide()
        this.toastr.success(result.message);
        this.mc="",
        this.mode="",
        this.pa="",
        this.pn="",
        this.qrMedium="",
        this.tn=""

      }else{
        this.spinner.hide();
        this.toastr.error(result.message)
      }
    })
  }

}
